import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 text-navy-200 py-12 px-6 md:px-12 border-t border-navy-800" data-id="element-43">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-44">
        <div className="flex flex-col items-center md:items-start" data-id="element-45">
          <div className="bg-white p-4 rounded-xl mb-4 inline-block" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/uRbkKVm2QnsBqNb5EX25cD/Queen_co_boat_company_logo.png" alt="Queen Boat Co." className="h-12 object-contain" data-id="element-47" />
          </div>
          <p className="text-sm text-navy-400 text-center md:text-left max-w-xs" data-id="element-48">
            Lake George Full Service Marina. Making boating easier and more
            enjoyable for our customers.
          </p>
        </div>

        <div className="text-sm text-navy-400 text-center md:text-right" data-id="element-49">
          <p data-id="element-50">
            &copy; {new Date().getFullYear()} Queen Boat Co. All rights
            reserved.
          </p>
          <p className="mt-2" data-id="element-51">Freedom Boat Club Lake George</p>
        </div>
      </div>
    </footer>;
}